/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import { __module as scheduler } from '../../_virtual/index3.js';
import { __require as requireScheduler_production_min } from './cjs/scheduler.production.min.js';
import { __require as requireScheduler_development } from './cjs/scheduler.development.js';

var hasRequiredScheduler;

function requireScheduler () {
	if (hasRequiredScheduler) return scheduler.exports;
	hasRequiredScheduler = 1;

	if (process.env.NODE_ENV === 'production') {
	  scheduler.exports = requireScheduler_production_min();
	} else {
	  scheduler.exports = requireScheduler_development();
	}
	return scheduler.exports;
}

export { requireScheduler as __require };
